import React from 'react';
export const AlertConfigContext = React.createContext(undefined);
export const AlertConfigProvider = (props) => {
    return React.createElement(AlertConfigContext.Provider, { value: props }, props.children);
};
